
(() => {
  const initialize = scope => {
    scope.querySelectorAll('[data-cc-services-hub]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const text = JSON.parse(root.querySelector('[data-cch-translations]').textContent);
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const scrollToContent = element => {
        const header = document.querySelector('.shopify-section-header');
        element.style.scrollMarginTop = ((header ? header.getBoundingClientRect().height : 0) + 24) + 'px';
        element.scrollIntoView({ behavior: reducedMotion.matches ? 'instant' : 'smooth', block: 'start' });
      };
      const panels = Array.from(root.querySelectorAll('[data-cch-panel]'));
      const choices = Array.from(root.querySelectorAll('[data-cch-select]'));
      const activate = (key, navigate = false) => {
        const panel = panels.find(item => item.dataset.cchPanel === key);
        if (!panel) return;
        panels.forEach(item => { item.hidden = item !== panel; });
        choices.forEach(item => {
          if (item.dataset.cchSelect === key) item.setAttribute('aria-current', 'location');
          else item.removeAttribute('aria-current');
        });
        root.querySelector('[data-cch-status]').textContent = text.shown + ' ' + panel.querySelector('h2').textContent;
        if (navigate) {
          if (location.protocol !== 'about:') history.replaceState(null, '', '#cch-' + key);
          panel.querySelector('h2').focus({ preventScroll: true });
          scrollToContent(panel);
        }
      };
      choices.forEach(choice => choice.addEventListener('click', event => { event.preventDefault(); activate(choice.dataset.cchSelect, true); }));
      root.querySelectorAll('a[href="#cch-services"]').forEach(link => link.addEventListener('click', event => {
        event.preventDefault();
        scrollToContent(root.querySelector('#cch-services'));
      }));
      const route = () => {
        const hash = location.hash;
        if (hash.startsWith('#smile-')) activate('rewards');
        else if (hash.startsWith('#cch-') && hash !== '#cch-services') activate(hash.slice(5));
      };
      activate('rental'); route();
      window.addEventListener('hashchange', route);

      const hireType = root.querySelector('[data-hire-type]');
      const hireParty = root.querySelector('[data-hire-party]');
      const rentalCards = Array.from(root.querySelectorAll('[data-rental-group]'));
      const filterRentals = () => {
        const group = hireType.value;
        const party = Number(hireParty.value);
        hireParty.disabled = group === 'individual';
        let count = 0;
        rentalCards.forEach(card => {
          const capacity = Number(card.dataset.capacity);
          const match = card.dataset.rentalGroup === group && (group === 'individual' || party === 0 || (party <= capacity && party <= 4));
          card.hidden = !match;
          if (match) count++;
        });
        root.querySelector('[data-rental-empty]').hidden = count !== 0;
        root.querySelector('[data-rental-status]').textContent = count + ' ' + (group === 'package' ? text.packages : text.individual);
      };
      hireType.addEventListener('change', () => { hireParty.value = '0'; filterRentals(); });
      hireParty.addEventListener('change', filterRentals);
      root.querySelector('[data-rental-reset]').addEventListener('click', () => { hireType.value = 'package'; hireParty.value = '0'; filterRentals(); hireParty.focus(); });
      filterRentals();

      const cleanSelect = root.querySelector('[data-clean-variant]');
      if (cleanSelect) {
        const updateCleanOption = () => {
          const option = cleanSelect.selectedOptions[0];
          const link = root.querySelector('[data-clean-link]');
          root.querySelector('[data-clean-price]').textContent = option.dataset.price;
          root.querySelector('[data-clean-stock]').hidden = option.dataset.available === 'true';
          link.href = link.dataset.productUrl + '?variant=' + option.value;
        };
        cleanSelect.addEventListener('change', updateCleanOption); updateCleanOption();
      }
      root.querySelectorAll('[data-market-mode]').forEach(button => button.addEventListener('click', () => {
        root.querySelectorAll('[data-market-mode]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        root.querySelectorAll('[data-market-content]').forEach(item => { item.hidden = item.dataset.marketContent !== button.dataset.marketMode; });
      }));

      root.querySelectorAll('[data-cch-request]').forEach(request => {
        const field = key => request.querySelector('[data-field="' + key + '"]');
        const value = key => field(key)?.value.trim() || '';
        let currentStep = 1;
        let files = [];
        const clearErrors = () => {
          request.querySelectorAll('[data-error]').forEach(item => { item.hidden = true; item.textContent = ''; });
          request.querySelectorAll('[aria-invalid]').forEach(item => item.removeAttribute('aria-invalid'));
        };
        const validate = step => {
          clearErrors();
          const names = step === 1 ? ['model', 'issue'] : ['name', 'email'];
          let firstInvalid = null;
          names.forEach(name => {
            const input = field(name);
            const missing = !input.value.trim();
            const invalidEmail = name === 'email' && !input.validity.valid;
            if (missing || invalidEmail) {
              input.setAttribute('aria-invalid', 'true');
              const error = request.querySelector('[data-error="' + name + '"]');
              error.textContent = missing ? text.required : text.email; error.hidden = false;
              if (!firstInvalid) firstInvalid = input;
            }
          });
          if (firstInvalid) { firstInvalid.focus({ preventScroll: true }); scrollToContent(firstInvalid.closest('.cch-field')); return false; }
          return true;
        };
        const renderSummary = () => {
          const summary = request.querySelector('[data-summary]'); summary.replaceChildren();
          const pairs = [];
          if (field('need')) pairs.push([text.request, field('need').selectedOptions[0].textContent]);
          if (field('order_known')?.value === 'yes' && value('order')) pairs.push([text.order, value('order')]);
          pairs.push([text.model, value('model')], [text.issue, value('issue')], [text.name, value('name')], [text.emailLabel, value('email')], [text.photos, files.length ? files.map(file => file.name).join('\n') : text.noFiles]);
          pairs.forEach(([label, content]) => { const dt = document.createElement('dt'); const dd = document.createElement('dd'); dt.textContent = label; dd.textContent = content; summary.append(dt, dd); });
        };
        const showStep = (step, focus = true) => {
          currentStep = step;
          request.querySelectorAll('[data-step]').forEach(item => { item.hidden = Number(item.dataset.step) !== step; });
          request.querySelector('[data-confirmation]').hidden = true;
          request.querySelector('.cch-progress').hidden = false;
          request.querySelectorAll('[data-step-label]').forEach(item => {
            if (Number(item.dataset.stepLabel) === step) item.setAttribute('aria-current', 'step');
            else item.removeAttribute('aria-current');
          });
          if (step === 3) renderSummary();
          request.querySelector('[data-request-status]').textContent = text.step + ' ' + step + ': ' + [text.details, text.contact, text.review][step - 1];
          if (focus) request.querySelector('[data-step="' + step + '"] input:not([disabled]), [data-step="' + step + '"] select, [data-step="' + step + '"] button')?.focus({ preventScroll: true });
          if (focus) scrollToContent(request);
        };
        const renderFiles = () => {
          const list = request.querySelector('[data-files]'); list.replaceChildren();
          files.forEach((file, index) => {
            const li = document.createElement('li'); const name = document.createElement('span'); const button = document.createElement('button');
            name.textContent = file.name; button.type = 'button'; button.textContent = text.remove; button.setAttribute('aria-label', text.remove + ' ' + file.name);
            button.addEventListener('click', () => { files.splice(index, 1); renderFiles(); field('photos').value = ''; });
            li.append(name, button); list.append(li);
          });
        };
        field('photos').addEventListener('change', () => {
          const error = request.querySelector('[data-file-error]'); error.hidden = true; error.textContent = '';
          let message = '';
          for (const file of Array.from(field('photos').files)) {
            if (!/\.(jpe?g|png|webp|heic|heif|pdf)$/i.test(file.name)) { message = text.fileType; continue; }
            if (file.size > 20 * 1024 * 1024 || files.length >= 5) { message = text.files; continue; }
            if (!files.some(existing => existing.name === file.name && existing.size === file.size && existing.lastModified === file.lastModified)) files.push(file);
          }
          field('photos').value = ''; renderFiles();
          if (message) { error.textContent = message; error.hidden = false; }
        });
        field('need')?.addEventListener('change', () => {
          const help = request.querySelector('[data-service-help]');
          help.textContent = ({ cleaning: text.cleaningHelp, repair: text.repairHelp, unsure: text.unsureHelp })[field('need').value];
          request.querySelector('[data-summary]').replaceChildren();
          request.querySelector('[data-confirmation]').hidden = true;
        });
        field('order_known')?.addEventListener('change', () => {
          const known = field('order_known').value === 'yes';
          request.querySelector('[data-order-field]').hidden = !known; field('order').disabled = !known;
          if (!known) field('order').value = '';
        });
        request.querySelectorAll('[data-next]').forEach(button => button.addEventListener('click', () => { if (validate(currentStep)) showStep(Number(button.dataset.next)); }));
        request.querySelectorAll('[data-back]').forEach(button => button.addEventListener('click', () => { clearErrors(); showStep(Number(button.dataset.back)); }));
        request.querySelector('[data-preview-finish]').addEventListener('click', () => {
          request.querySelectorAll('[data-step]').forEach(item => { item.hidden = true; });
          request.querySelector('.cch-progress').hidden = true;
          request.querySelector('[data-confirmation]').hidden = false;
          request.querySelector('[data-request-status]').textContent = text.confirmation;
          request.querySelector('[data-reset-request]').focus({ preventScroll: true });
          scrollToContent(request);
        });
        request.querySelector('[data-reset-request]').addEventListener('click', () => {
          request.querySelectorAll('input,textarea').forEach(input => { input.value = ''; });
          request.querySelectorAll('select').forEach(select => { select.selectedIndex = 0; select.dispatchEvent(new Event('change', { bubbles: true })); });
          files = []; renderFiles(); clearErrors(); request.querySelector('[data-file-error]').hidden = true;
          request.querySelector('[data-summary]').replaceChildren(); showStep(1);
        });
        showStep(1, false);
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  else initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
